import script from "./SepultureTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./SepultureTypes.vue?vue&type=script&setup=true&lang=js"

import "./SepultureTypes.vue?vue&type=style&index=0&id=2662e4ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2662e4ba"]])

export default __exports__